import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
      <svg
        width={27}
        height={27}
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_2276_6944)">
          <path
            d="M14.577 19.125H1.172l6.703-4.788 6.702 4.788zM.563 25.828h14.624M7.875 19.126v6.657M12.75 19.146v6.668M3 19.121v6.713M25.827 5.913H12.422l6.703-4.788 6.702 4.788zM11.813 12.616h14.624M19.125 5.904v6.725M24 5.914v6.694M14.25 5.924v6.704M1.125 10.125V4.5h4.5"
            stroke={theme["#0D968F"]}
            strokeWidth={2}
            strokeLinejoin="round"
          />
          <path d="M5.625 8.1V.9l4.5 3.6-4.5 3.6z" fill={theme["#0D968F"]} />
          <path
            d="M25.875 16.875V22.5h-4.5"
            stroke={theme["#0D968F"]}
            strokeWidth={2}
            strokeLinejoin="round"
          />
          <path d="M21.375 18.9v7.2l-4.5-3.6 4.5-3.6z" fill={theme["#0D968F"]} />
        </g>
        <defs>
          <clipPath id="clip0_2276_6944">
            <path fill="#fff" d="M0 0H27V27H0z" />
          </clipPath>
        </defs>
      </svg>
    )
  }
  
  export default SvgComponent